import { Component, Input, OnInit } from '@angular/core';
import { CostService } from '../../../../service/cost.service';
import { NzMessageService } from 'ng-zorro-antd/message';
import { NzModalRef, NzModalService } from 'ng-zorro-antd/modal';
import { AuthState } from '../../../../store/authInfo/auth-state';
import { Store } from '@ngxs/store';
import { JobCostComponent } from '../job-cost/job-cost.component';

@Component({
  selector: 'app-job-cost-list',
  templateUrl: './job-cost-list.component.html',
  styleUrls: ['./job-cost-list.component.less']
})
export class JobCostListComponent implements OnInit {
  @Input() jobId: any;
  jobCostList = [];
  authState = null;
  isFocus = false; // 鼠标移入为true.鼠标移出设置为false，默认为false
  constructor(
    private costService: CostService,
    private message: NzMessageService,
    private modal: NzModalRef,
    private modalService: NzModalService,
    private store: Store,
  ) {
  }

  ngOnInit() {
    this.authState = this.store.selectSnapshot<any[]>(AuthState);
    this.initCostList();
  }
  async delete(item){
    this.modalService.confirm({
      nzTitle: '删除费用?',
      nzContent: '<b style="color: red;">确定要删除当前选择的费用吗</b>',
      nzOkText: '确定',
      nzOkType: 'primary',
      nzOkDanger: true,
      nzOnOk: async () => {
        item.delFlag = 1;
        const result = await this.costService.updateCost(item);
        if (result !== null){
          this.initCostList();
          this.message.info('删除成功');
        }
      },
      nzCancelText: '取消',
      nzOnCancel: () => console.log('Cancel')
    });
  }
  async initCostList(){
    const list = await this.costService.getCostByJobId(this.jobId);
    list.forEach((item) => {
      item.edit = false;
    });
    this.jobCostList = list;
    if (this.jobCostList.length === 0){
      this.modal.destroy(this.jobCostList.length);
    }
  }
  addCost(){
    const modalCost = this.modalService.create({
      nzTitle: '费用填报',
      nzContent: JobCostComponent,
      nzStyle: { top: '40px' },
      nzWidth: 650,
      nzOnOk: async (ev: any) => {
        // const instance = modalCost.getContentComponent();
        // const form = instance.getCostForm();
        const form = ev.getCostForm();
        // tslint:disable-next-line:forin
        if (!ev.validateCostFormData(form)) {
          return false;
        } else {
          const cost = {
            money: form.value.money,
            costDesc: this.isEmpty(form.value.costDesc) ? '' : form.value.costDesc,
            costType: form.value.costType,
            relatedProvideId: this.isEmpty(form.value.relatedProvideId) ? null : form.value.relatedProvideId,
            relatedJobId: this.jobId,
            createBy: this.authState.userInfo.userId
          };
          const result: any = await this.costService.addCost(cost);
          if (result.code === 200) {
            this.message.success('费用添加成功');
            this.initCostList();
            // return result.data;
          } else {
            this.message.error('费用添加失败');
            return false;
          }
        }
      },
      nzOnCancel: (ev) => {
      }
    });
  }
  public isEmpty(obj: any) {
    if (typeof obj === 'undefined' || obj === null || obj === '') {
      return true;
    } else {
      return false;
    }
  }
  // mouseEnter(){
  //   this.isFocus = true;
  // }
  // mouseLeave(){
  //   this.isFocus = false;
  // }
}
